import React, { FC, useEffect } from 'react';
import { capitalize } from 'lodash';

import { Scrollbar } from 'app/design-system/components/Scrollbar';
import { useTranslation } from 'app/lang';
import { ToggleThemeState, useTheme } from 'app/lib/theme';
import { getBrandName } from 'app/packages/brand';
import { MobileOS } from 'app/packages/lib/mobile/getOperationSystem';
import { BrandLogo } from 'app/widgets/BrandLogo';

import { AndroidInstruction } from './components/AndroidInstruction';
import { IOSInstruction } from './components/IOSInstruction';

import dictionary from './MobileLayout.dictionary.json';

import styles from './MobileLayout.module.scss';

type MobileLayoutProps = {
  os: MobileOS;
};

export const MobileLayout: FC<MobileLayoutProps> = ({ os }) => {
  const { t } = useTranslation();
  const { setTheme } = useTheme();

  useEffect(() => {
    // TODO: CP-934
    // Удалить когда будет по-умолчанию установлена системная тема на SSR
    setTheme(ToggleThemeState.SYSTEM);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <BrandLogo width={104}
                     height={22} />
          <h1 className={styles.title}>
            {t(dictionary.title, { brand: capitalize(getBrandName()) })}
          </h1>
        </div>
      </div>
      <Scrollbar className={styles.scrollbar}>
        <div className={styles.instruction}>
          {os === 'iOS' ? (
            <IOSInstruction />
          ) : (
            <AndroidInstruction />
          )}
        </div>
      </Scrollbar>
    </div>
  );
};
